import UserInfoModule from './containers/userInfoModule'

export {default as UserInfoModuleLayout} from './components/userInfoModuleLayout'

export default UserInfoModule
